import { get}  from '../state/quick-search.state';
import { sdkLogHelper}  from '../../../../../../shared/helpers/sdk-log.helper';
import { SearchHitProductModel}  from '../models/search-result.model';

enum QuickProductLogEvents {
  NOTHING_FOUND = 'quick_product_search_nothing_found',
  PRODUCT_CLICKED = 'quick_product_search_product_clicked',
  ERROR = 'quick_product_search_error',
}

export class QuickProductSearchLogService {
  static handleNothingFound() {
    if (get('result') !== null && !get('result')?.total) {
      sdkLogHelper(QuickProductLogEvents.NOTHING_FOUND, {
        query: get('query'),
      });
    }
  }
  static handleProductClicked(item: SearchHitProductModel) {
    sdkLogHelper(QuickProductLogEvents.PRODUCT_CLICKED, {
      query: get('query'),
      item: item,
    });
  }
  static handleError(error) {
    sdkLogHelper(QuickProductLogEvents.ERROR, {
      error: error,
    });
  }
}
